import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-search-icon',
  templateUrl: './search-icon.component.html',
  styleUrls: ['./search-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchIconComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
